<template>
    <div>
        <div class="py-4 d-none">
            <div class="dropdown">
                <div class="alert alert-secondary" role="alert">
                    <p class="lead">Welcome Back, {{this.userData.user}}</p>
                    <p v-if="this.isAdmin"><em>Administrator</em></p>
                    <p v-else><em>{{this.userData.roles}}</em></p>
                </div>
            </div>
        </div>
        <div class="content-header text-center">
            <h2>Send Test Email</h2>
        </div>
        <div class="container-fluid min-content-height">
            <div class="row">
                <div class="col">
                    <div class="card card-body">
                        <form id="smtpform" v-on:submit.prevent="send_email">
                            <div class="mb-3">
                                <label for="email" class="form-label">To Email</label>
                                <input type="email" class="form-control" id="email" name="email" aria-describedby="email" v-model="form.email">
                            </div>
                            <div class="mb-3">
                                <label for="subject" class="form-label">Subject</label>
                                <input type="text" class="form-control" id="subject" name="subject" aria-describedby="subject" v-model="form.subject">
                            </div>
                            <div class="mb-3">
                                <label for="message" class="form-label">Message</label>
                                <textarea class="form-control" height="500" id="message" name="message" aria-describedby="message" v-model="form.message"></textarea>
                            </div>
                            <button type="submit" class="btn btn-primary">Submit</button>
                        </form>
                    
                    </div>
                </div>
                
            </div>
            
        </div>
    </div>
</template>
<script>
import axios from 'axios';
export default {
    name: 'SMTPTest',
    props: {
        userData: [],
        isAdmin: {
            type: Boolean,
            default() {
                return false
            }
        }
    },
    data(){
        return{
            form: {
                email: '',
                subject: '',
                message: ''
            }
        }
    },
     methods: {  
        send_email() {
            const intialFormData = new FormData(document.getElementById("smtpform"));
            const serializedSessionId = new URLSearchParams(intialFormData).toString();
            // console.log(JSON.stringify(this.form.email))
            axios.get('/send_email',  {params: {email: this.form.email, subject: this.form.subject, message: this.form.message }})
            .then(
            (response) => {
                // console.log('Email Sent: '+JSON.stringify(response.data));
                this.$emit('customChange', {shell: 'SMTPTest', dataset: ''});
            }
            )
            .catch(
            (error) => {
                this.errorMessage = error.message;
                console.error("There was an error!", error);
                }
            );
        },
        
    },
    mounted() {

    }
}

</script>